/** Default same-origin Admin/contractor API base for local Vite DEV. */
export const DEFAULT_DEV_API_BASE_URL = '/api/v1';

/**
 * Strips trailing slashes so `${base}${path}` with paths like `/auth/login`
 * never produces `//auth`.
 */
export function normalizeApiBaseUrl(raw: string): string {
  const trimmed = raw.trim().replace(/\/+$/, '');
  return trimmed.length > 0 ? trimmed : DEFAULT_DEV_API_BASE_URL;
}

export function composeApiRequestUrl(baseUrl: string, path: string): string {
  const base = normalizeApiBaseUrl(baseUrl);
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${base}${normalizedPath}`;
}
